import React, {useState} from "react"
import {useMenu} from "react-instantsearch"
import ShowMore from "@bodeboca/algolia/components/filters/show-more"
import {useTranslation} from "react-i18next"
import CommonUtils from "@bodeboca/utils"

type Props = {
  title: string;
  attribute: string;
  sortBy?: any;
  showMore?: boolean;
  limit?: number;
  showMoreLimit?: number;
  isAlgolia?: boolean;
};
const MenuFilter = ({
  title, attribute, sortBy = ["count:desc"], showMore = true, limit = 3, key, showMoreLimit
}: Props) => {
  const {t} = useTranslation()

  function CustomMenuFilter(props: Props) {
    const {
      items,
      refine,
      createURL,
      toggleShowMore,
      isShowingMore,
      canToggleShowMore,
    } = useMenu(props)
    const [open, setOpen] = useState(false)

    return (<>
      {items.length > 1 && <div
        className={"bb-filter-options " + (open ? "filter-options-mobile-open" : "")}
        key={key}>
        <h4 className="bb-filter-processed" onClick={() => setOpen(!open)}>
          {t(title)}
        </h4>
        <div className="ais-Menu item-list">
          <ul className="ais-Menu-list dropdown-menu">
            {items.map((item) => (<li
              className="ais-Menu-item dropdown-menu-item"
              key={item.label}>
              <a
                className="ais-Menu-link"
                style={{fontWeight: item.isRefined ? "bold" : "normal"}}
                onClick={(event) => {
                  event.preventDefault()

                  refine(item.value)
                  CommonUtils.onStateChange()
                  setOpen(!open)
                }}>
                <span className="ais-Menu-label">{item.label}</span>
                <span className="ais-Menu-count">{item.count}</span>
              </a>
            </li>))}
          </ul>
          {props.showMore && canToggleShowMore && <ShowMore
            isShowingMore={isShowingMore}
            showMore={showMore}
            toggleShowMore={toggleShowMore}/>}
        </div>
      </div>}
    </>)
  }

  return (<CustomMenuFilter
    attribute={attribute}
    limit={limit !== undefined ? limit : 3}
    showMore={showMore !== undefined ? showMore : true}
    sortBy={sortBy}
    title={title}/>)
}
export default MenuFilter
